import { render, staticRenderFns } from "./healthquestions.vue?vue&type=template&id=d9fdde5e&scoped=true"
import script from "./healthquestions.vue?vue&type=script&lang=js"
export * from "./healthquestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fdde5e",
  null
  
)

export default component.exports